import {
    useCommonActsKC2GroupManager,
    useCommonActsKc2GroupManagerData,
} from 'pages/Project/Common/ActsKC2ListContainer/hooks';

import { useCallback } from 'react';

import { uerIsUniqueActKC2GroupNameGql, uerWorkOrderActsKC2SelectionListGql } from '../uerWorkOrderActsKc2ListQueries';

import { useUerActsKc2GroupManagerColumns } from './useUerActsKc2GroupManagerColumns';
import { useUerActsKc2GroupSaver } from './useUerActsKc2GroupSaver';

export const useUerActsKc2GroupManager = ({
    workOrderId,
    actKC2GroupId,
    refreshActListData,
    handlerCloseEditGroup,
}: {
    workOrderId: number;
    actKC2GroupId: number | null;
    refreshActListData: () => void;
    handlerCloseEditGroup: () => void;
}) => {
    const { groupManagerData, isLoading, defaultData, groupManagerOpened, handleToggleModalState } =
        useCommonActsKc2GroupManagerData({
            workOrderId,
            actKC2GroupId,
            handlerCloseEditGroup,
            getDataQuery: uerWorkOrderActsKC2SelectionListGql,
        });

    const { control, handleSubmit, isDirty, allUnchecked, isNotUniqueActKC2GroupName } = useCommonActsKC2GroupManager({
        actKC2GroupId,
        defaultData,
        groupManagerOpened,
        workOrderId,
        uniqueGroupNameQuery: uerIsUniqueActKC2GroupNameGql,
    });

    const groupManagerColumns = useUerActsKc2GroupManagerColumns({ control });

    const onSuccess = useCallback(() => {
        refreshActListData();
        handleToggleModalState();
    }, [handleToggleModalState, refreshActListData]);

    const { isCommit, handleSaveGroup } = useUerActsKc2GroupSaver({ workOrderId, onSuccess, actKC2GroupId });

    return {
        control,
        groupManagerColumns,
        groupManagerData: groupManagerData?.uerWorkOrderActsKC2RegistrySelectionList?.items ?? [],
        groupManagerOpened,
        handleToggleModalState,
        isLoading,
        handleSaveGroup: handleSubmit(handleSaveGroup),
        isCommit,
        isConfirmDisabled: allUnchecked || isNotUniqueActKC2GroupName,
        isFormDirty: isDirty,
    };
};
